<template>
  <div id="Jibenzoushi">
    <div class="tr-header">
      <p class="title">历史号码统计</p>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Jibenzoushi",
  data() {
    return {
      columns: [],
      pageSize: 30,
      dataSource: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // this.reset();
        this.getDate();
      }
    }
  },
  methods: {
    reset(data) {
      this.columns = columns(this.betType, data).list(this);
      // this.lostColumns = columns(this.betType, data).lostList(this);
    },
    async getDate() {
      let req = {
        gameType: this.$route.params.gameType
        // pageSize: 30,
        // startRow: 0
      };
      let res = await this.$http.post("/queryKcDateReport.do", req);
      if (res.data.returnCode == "0000") {
        var arr = format.formatJson(res.data.returnList);
        this.reset(arr);
        this.dataSource = arr;
        console.log(arr);
        // console.log(arr);
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Lishihaomatongji/index.vue